import { render } from "./thirdPartySharing.vue?vue&type=template&id=58479920"
const script = {}

import "./thirdPartySharing.vue?vue&type=style&index=0&id=58479920&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__